import { Card, CardAction, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Spinner } from '@/components/ui/spinner';

/**
 * Wat je ziet terwijl de hulpvragen worden gezocht.
 *
 * Eén call over de hele samenvatting, dus er is geen tussenstand: geen teller,
 * geen tekst die volloopt. Hier stond een voortgangsbalk en een rij vondsten uit
 * een opzet die de tekst nog opknipte; niets vulde die meer, dus stond de balk
 * altijd op nul en bleef het scherm "Samenvatting lezen…" zeggen. Wat overblijft
 * is dat er iets draait, en dat is precies wat er te melden valt.
 */
export function BezigMetZoeken() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Hulpvragen zoeken</CardTitle>
        <CardDescription>Samenvatting doorlezen…</CardDescription>
        <CardAction>
          <Spinner className="size-5 text-primary" />
        </CardAction>
      </CardHeader>
    </Card>
  );
}
